<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row
    class="mx-0"
    :class="{ v3_heading_mobile_view: $vuetify.breakpoint.smAndDown }"
  >
    <v-col
      cols="8"
      md="6"
      style="padding-left:0px; padding-top: 10px; padding-bottom: 10px;"
    >
      <span class="headline font-weight-light">
        {{ title }}
        <v-icon
          slot="divider"
          @click="reloadAllData()"
          style="padding-bottom: 2px;"
          >mdi-refresh</v-icon
        >
      </span>

      <v-breadcrumbs
        :items="breadcrumbs"
        style="padding-left: 0; padding-bottom: 0;"
      >
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
    </v-col>

    <v-col cols="4" md="6" style="text-align: right;" v-show="rightColumn">
      <v-tooltip
        bottom
        v-for="action in heading_actions"
        v-bind:key="action.icon"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            small
            dark
            color="primary"
            class="pa-4 mx-2 my-1"
            @click="handleAction(action.callback)"
          >
            <v-icon>{{ action.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ action.tooltip }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            small
            dark
            color="primary"
            class="pa-4 mx-2 my-1"
            @click="showFilters = !showFilters"
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ showFilters ? "Sakrij" : "Prikaži" }} filtere</span>
      </v-tooltip>

      <!--
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon color="blue darken-2" large dark>
                        <download-excel
                                :data="jsonData"
                                :fields="jsonFields"
                                :name="getFileName()">
                            <v-icon>description</v-icon>
                        </download-excel>
                    </v-btn>
                </template>
                <span>Izvoz u CSV</span>
            </v-tooltip>
           -->
    </v-col>

    <v-row v-if="rightColumn">
      <v-col cols="12" md="4">
        <v-text-field
          outlined
          @input="performSearch"
          label="Pretraga"
          v-model="search.phrase"
          hide-details
          dense
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          outlined
          :items="headers"
          hide-details
          label="Odaberi stupac.."
          v-model="search.field"
          dense
        ></v-select>
      </v-col>
      <v-col cols="12" md="2"></v-col>
      <v-col cols="12" md="2">
        <v-btn
          color="primary"
          dark
          width="100%"
          class="text-none"
          @click="showAddForm()"
          v-if="$route.matched[0].name !== 'DepartmentTableView'"
        >
          <v-icon left size="20">mdi-plus</v-icon>
          Dodaj
        </v-btn>
      </v-col>
    </v-row>

    <v-col cols="12">
      <v-fade-transition mode="out-in">
        <v-row class="pl-0 ml-0" v-if="showFilters" style="padding: 0 24px">
          <v-col cols="12" style="padding: 0 8px;">
            <!--<v-divider></v-divider>-->
            <div
              style="height: 1px; background: linear-gradient(90deg,#fff,#084776,#fff);"
            ></div>
          </v-col>
          <v-col cols="12">
            <div class="text-h5 primary--text font-weight-bold">
              Prikaz filtera
            </div>
          </v-col>
          <v-col
            cols="12"
            md="4"
            v-for="item in filterItems"
            :key="`key_${item.name}`"
          >
            <v-autocomplete
              v-model="filters[item.name]"
              :label="item.title"
              :items="item.source"
              :prepend-icon="item.icon"
            >
            </v-autocomplete>
          </v-col>
          <v-col class="ml-0" cols="12" md="4" style="margin-left: 15px;">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              format="d.m.Y"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  dense
                  v-model="filters.date_from"
                  label="Napravljeno od.."
                  prepend-icon="mdi-calendar-arrow-right"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  width="100%"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="hr"
                v-model="date_from"
                @input="handleFilterDates('date_from')"
              ></v-date-picker>
            </v-menu>
            <!--<v-menu-->
            <!--:nudge-right="40"-->
            <!--:close-on-content-click="true"-->
            <!--format="d.m.Y"-->
            <!--offset-y-->
            <!--full-width-->
            <!--min-width="290px"-->
            <!--transition="scale-transition">-->

            <!--<v-text-field-->
            <!--slot="activator"-->
            <!--v-model="filters.date_from"-->
            <!--label="Napravljeno od.."-->
            <!--prepend-icon="mdi-calendar-arrow-right"-->
            <!--readonly>-->
            <!--</v-text-field>-->

            <!--<v-date-picker-->
            <!--v-model="date_from"-->
            <!--@input="handleFilterDates('date_from')">-->
            <!--</v-date-picker>-->
            <!--</v-menu>-->
          </v-col>

          <v-col cols="12" md="4" class="ml-0" style="margin-left: 15px;">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              format="d.m.Y"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  dense
                  v-model="filters.date_to"
                  label="Napravljeno do.."
                  prepend-icon="mdi-calendar-arrow-left"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  width="100%"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="hr"
                v-model="date_to"
                @input="handleFilterDates('date_to')"
              ></v-date-picker>
            </v-menu>
            <!--<v-menu-->
            <!--:nudge-right="40"-->
            <!--:close-on-content-click="true"-->
            <!--offset-y-->
            <!--full-width-->
            <!--min-width="290px"-->
            <!--transition="scale-transition">-->

            <!--<v-text-field-->
            <!--slot="activator"-->
            <!--v-model="filters.date_to"-->
            <!--label="Napravljeno do.."-->
            <!--prepend-icon="mdi-calendar-arrow-left"-->
            <!--readonly>-->
            <!--</v-text-field>-->

            <!--<v-date-picker-->
            <!--v-model="date_to"-->
            <!--@input="handleFilterDates('date_to')">-->
            <!--</v-date-picker>-->
            <!--</v-menu>-->
          </v-col>

          <!--
                    <v-col cols="2" style="margin-left: 15px;">
                        <v-btn depressed color="primary" big
                               @click="cancelFilters()">
                            Poništi filtere
                        </v-btn>
                    </v-col>
                    -->
        </v-row>
      </v-fade-transition>
    </v-col>
  </v-row>
</template>

<script>
import { serverBus } from "../../main";

export default {
  props: ["rightColumn"],

  created() {
    this.getGeneralData();
    this.getCurrentTime();

    serverBus.$on("change-title", (title) => {
      this.title = title;
    });

    serverBus.$on("headers-change", (headers) => {
      this.headers = [this.headers[0]];

      for (let i = 0; i < headers.length; i++)
        if (headers[i].searchable) this.headers.push(headers[i]);

      if (this.$getTable() === "djelatnik" || this.$getTable() === "ucenik") {
        this.headers.splice(1, 0, {
          field: "name",
          text: "Ime i prezime",
          value: "name",
        });
      }

      this.jsonFields = {};

      if (this.headers.length > 0) this.search.field = this.headers[0].value;

      for (let i = 0; i < headers.length; i++) {
        this.jsonFields[headers[i].text] = headers[i].value;
      }
    });
    // serverBus.$on("set-search", (item) => {
    //   this.search = item;
    // });
  },

  computed: {
    jsonData: function() {
      return this.$getData();
    },
  },

  methods: {
    getGeneralData() {
      this.$axios.post(this.$getTable() + "/opcenito").then((response) => {
        this.singular = response.data["singular"];
        this.breadcrumbs = response.data["breadcrumbs"];
        this.heading_actions = response.data["heading_actions"];

        this.$store.commit("setEditInDialog", response.data["edit_in_dialog"]);

        if (this.title === "") this.title = response.data["title"];
      });
    },

    showAddForm: function() {
      console.log(this.$route);
      if (this.$route.fullPath == "/admin/ucenik") {
        serverBus.$emit("show-student-add-form", { id: -1 });
      } else if (this.$route.fullPath == "/admin/djelatnik") {
        serverBus.$emit("show-employee-add-form", { id: -1 });
      } else if (this.$route.fullPath == "/admin/zupanija") {
        serverBus.$emit("show-canton-add-form", { id: -1 });
      } else {
        serverBus.$emit("show-add-form", { id: -1 });
      }
    },

    performSearch: function() {
      let self = this;

      clearTimeout(this.searchTimeout);

      this.searchTimeout = null;
      this.searchTimeout = setTimeout(function() {
        serverBus.$emit("perform-search", self.search);

        self.searchTimeout = null;
      }, 300);
    },

    getTableFilters() {
      this.loading = true;

      this.$axios
        .post(this.$getTable() + "/filteri")
        .then((response) => {
          this.filterItems = response.data;

          for (let i = 0; i < this.filterItems.length; i++) {
            this.$set(this.filters, this.filterItems[i].name, "");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    cancelFilters() {
      this.filters = {};

      this.reloadAllData();
    },

    handleFilterDates(date) {
      if (date === "date_from") {
        this.filters.date_from = this.$parseDate(this.date_from);
        this.menu = false;
      } else if (date === "date_to") {
        this.filters.date_to = this.$parseDate(this.date_to);
        this.menu1 = false;
      }

      if (this.filters.date_from && this.filters.date_to) {
        this.reloadAllData();
      }
    },

    getExportFilename() {
      return (
        this.table +
        "_" +
        new Date().toLocaleDateString() +
        "_" +
        new Date().toLocaleTimeString() +
        ".xls"
      );
    },

    reloadAllData() {
      this.search = {
        phrase: "",
        field: "everything",
      };
      serverBus.$emit("reload-all-data");
    },

    handleAction(action) {
      switch (action) {
        case "print-page":
          this.printPage();
          break;
      }
    },

    printPage() {
      this.getCurrentTime();
      setTimeout(function() {
        window.print();
      }, 200);
    },

    getCurrentTime() {
      let today = new Date();
      this.currentTime = today.toLocaleString();
    },
  },

  watch: {
    filters: {
      handler() {
        serverBus.$emit("filters-changed", this.filters);
      },
      deep: true,
    },

    showFilters: {
      handler() {
        if (this.showFilters && this.filterItems.length === 0) {
          this.getTableFilters();
        } else {
          this.cancelFilters();
        }
      },
    },

    $route() {
      this.filters = {};
      this.getGeneralData();

      if (this.showFilters && this.filterItems.length === 0) {
        this.getTableFilters();
      }
    },
  },

  data: function() {
    return {
      title: "",
      singular: "",
      filters: {},
      filterItems: [],
      breadcrumbs: [],
      heading_actions: [],
      jsonFields: {},
      showFilters: false,
      date_from: null,
      date_to: null,
      currentTime: null,
      menu: false,
      menu1: false,
      search: {
        phrase: null,
        field: "everything",
      },
      searchTimeout: null,
      headers: [{ value: "everything", text: "Sva polja.." }],
    };
  },
};
</script>
